module.exports = __webpack_public_path__ + "img/placeholdernew.fbc4d367.jpg";